export function billingDate(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-AU', {
    timeZone: 'Australia/Melbourne', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const part = name => parts.find(item => item.type === name).value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}

export function monday(value) {
  const date = value instanceof Date
    ? new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()))
    : new Date(`${String(value).slice(0, 10)}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 6) % 7);
  return date.toISOString().slice(0, 10);
}

export function previousWeek(now = new Date()) {
  const date = new Date(`${monday(billingDate(now))}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() - 7);
  return date.toISOString().slice(0, 10);
}

export function weekLabel(start) {
  if (!start) return '';
  const end = new Date(`${start}T00:00:00Z`);
  end.setUTCDate(end.getUTCDate() + 6);
  return `${start} – ${end.toISOString().slice(0, 10)}`;
}

// Round decimal strings directly so large amounts and halfway values keep their precision.
export function decimal(value) {
  if (value === null || value === undefined) return '—';
  const match = String(value).trim().match(/^([+-]?)(\d+)(?:\.(\d*))?(?:e([+-]?\d+))?$/i);
  if (!match) return '—';
  const exponent = Number(match[4] || 0);
  if (!Number.isSafeInteger(exponent) || Math.abs(exponent) > 1000) return '—';
  const digits = match[2] + (match[3] || '');
  const point = match[2].length + exponent;
  const integer = (point <= 0 ? '0' : digits.slice(0, point).padEnd(point, '0')).replace(/^0+(?=\d)/, '');
  const fraction = (point < 0 ? '0'.repeat(-point) + digits : digits.slice(point)).padEnd(3, '0');
  const rounded = (integer + fraction.slice(0, 2)).split('');
  if (fraction[2] >= '5') {
    let carry = 1;
    for (let index = rounded.length - 1; index >= 0 && carry; index -= 1) {
      const digit = Number(rounded[index]) + carry;
      rounded[index] = String(digit % 10);
      carry = digit === 10 ? 1 : 0;
    }
    if (carry) rounded.unshift('1');
  }
  const sign = match[1] === '-' && rounded.some(digit => digit !== '0') ? '-' : '';
  return `${sign}${rounded.slice(0, -2).join('')}.${rounded.slice(-2).join('')}`;
}

export function money(value) {
  return decimal(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function requestId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
}

export function reviewLocation(row) {
  return {
    name: 'BusinessBillingInvoiceReview',
    query: {
      invoiceId: String(row.invoiceId || row.id),
      weekStart: row.invoiceWeekStart || monday(billingDate(new Date(row.periodFrom))),
    },
  };
}

export function parseLog(content) {
  try { return typeof content === 'string' ? JSON.parse(content) : content; } catch (e) { return content; }
}

export function hasReviewPermission(tree, code) {
  return (tree || []).some(node => node.code === code || hasReviewPermission(node.children, code));
}
